module.exports = __webpack_public_path__ + "static/media/MANEJO_VENTAS.741de1bc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/archivos/MANEJO_VENTAS.pdf
// module id = 77
// module chunks = 0